module.exports = __webpack_public_path__ + "img/xfg.6c3f78d4.png";